// extracted by mini-css-extract-plugin
module.exports = {"confirmation-status":"ConfirmationStatus_confirmation-status__1sG6d"};